<script setup>
  import {onMounted, onUpdated, ref} from "vue";

  import ComponentAlert from "@components/Alerts/Alert.vue";
  import ComponentBmpImportDialogRequestedPage from "@components/Dialogs/BmpImportDialog/Tabs/RequestedPage.vue";
  import {debounce} from "es-toolkit";

  defineOptions({
    name: "ComponentBmpImportDialogBarcodeScannerTab",
  });

  defineProps({
    error: {
      type: Object,
      required: true,
    },
    requestedPage: {
      type: String,
      default: null,
    },
  });

  const emit = defineEmits(["input", "skip"]);

  const refInput = ref(null);

  onMounted(() => {
    setFocus();
  });

  onUpdated(() => {
    setFocus();
  });

  const processTextInput = debounce((event) => {
    emit("input", event.target.value);
    refInput.value.value = "";
    setFocus();
  }, 1000);

  const setFocus = () => {
    setTimeout(() => {
      if (refInput.value) {
        refInput.value.focus();
      }
    }, 50);
  };

  defineExpose({
    setFocus,
  });
</script>

<template>
  <div class="mt-5">
    <!-- Click handler ensures hidden barcode input stays focused for scanner input -->
    <!-- eslint-disable-next-line vuejs-accessibility/no-static-element-interactions, vuejs-accessibility/click-events-have-key-events -->
    <div class="flex flex-col gap-3" @click="setFocus">
      <h3 class="text-lg leading-6 font-medium text-gray-700">BMP-Datamatrix scannen</h3>

      <ComponentAlert
        v-if="error.type && error.text"
        :type="error.type"
        class="mb-0!"
        :test-id="getTestId('barcode-scanner-tab')"
      >
        {{ error.text }}
      </ComponentAlert>

      <ComponentBmpImportDialogRequestedPage
        v-if="requestedPage"
        :requested-page="requestedPage"
        :test-id="testId + '-requested-page'"
        @skip="$emit('skip')"
      />

      <p>Bitte jetzt die Datamatrix mit einem apothekenüblichen Barcodescanner einlesen.</p>

      <div class="flex justify-center">
        <img src="@assets/icons/barcodescanner.svg" alt="Barcodescanner" />
      </div>
    </div>

    <input
      ref="refInput"
      class="size-0 border-none focus:ring-0 focus:outline-none"
      :data-test="getTestId('barcode-scanner-tab-input')"
      @input="processTextInput"
    />
  </div>
</template>
